import { Component } from '@angular/core'
import { ObjectWidget } from 'ngx-schema-form'

@Component({
  selector: 'app-object-widget',
  templateUrl: './object-widget.component.html',
  styleUrls: ['./object-widget.component.scss'],
})
export class ObjectWidgetComponent extends ObjectWidget {}
